import request from '@/utils/https';

/**
 * configKey
 * 获取字典配置
 * @param {*} configKey
 */
export const getConfigKey = configKey => {
  return request({
    url: `/system/dict/data/type/v2/` + configKey,
    method: 'get',
  });
}
//获取参数
export const getConfigTxt = configKey => {
  return request({
    url: `/system/config/configKey/` + configKey,
    method: 'get',
  });
}

export const uploadFile = (formData) => {
  return request({
    url: '/resource/oss/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data', // 必须设置
    },
  });
}
export const browserCheckFlag = () => {
  return request({
    url: `/auth/uaa/browserCheckFlag`,
    method: 'get',
  });
}

//获取OEM配置
export const getOemConfig = (params) => {
  return request({
    url: `/auth/tenant/list`,
    method: 'get',
    params,
  });
}
